import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import {ChatStyle, ColorCoding, OpenChat} from "../../../model2/chat/chat/const";
import {BackGround} from "../../../gd-app/panels/preferences-panel/settings-background/settings-background";

const fieldsConfig = {

    'openChatMenu': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : OpenChat.FULLSCREEN,
        options         : [OpenChat.FULLSCREEN, OpenChat.WINDOW]
    },
    'openChatLink': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : OpenChat.FULLSCREEN,
        options         : [OpenChat.FULLSCREEN, OpenChat.WINDOW]
    },

    'chatStyleOneToOne': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : ChatStyle.CLASSIC,
        options         : [ChatStyle.CLASSIC, ChatStyle.BUBBLES]

    },
    'chatStyleGroup': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : ChatStyle.CLASSIC,
        options         : [ChatStyle.CLASSIC, ChatStyle.BUBBLES]

    },
    'chatStyleDiscussion': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : ChatStyle.CLASSIC,
        options         : [ChatStyle.CLASSIC, ChatStyle.BUBBLES]

    },

    'backgroundColor': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : BackGround.GRAY,
        options         : [BackGround.GRAY, BackGround.WHITE]
    },
    'colorCoding': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : ColorCoding.MONO,
        options         : [ColorCoding.MONO, ColorCoding.COLORED]
    }
}

const debug = false
// const debug = "UserSettingsViewsChat"

export default class UserSettingsViewsChat extends ServerSettings {

    public openChatMenu         : OpenChat
    public openChatLink         : OpenChat
    public chatStyleOneToOne    : ChatStyle
    public chatStyleGroup       : ChatStyle
    public chatStyleDiscussion  : ChatStyle
    public colorCoding          : ColorCoding
    public backgroundColor      : BackGround

    constructor(config: any) {

        super(config, fieldsConfig);

        // default current view
        this.openChatMenu           = this.initValue('openChatMenu')
        this.openChatLink           = this.initValue('openChatLink')
        this.chatStyleOneToOne      = this.initValue('chatStyleOneToOne')
        this.chatStyleGroup         = this.initValue('chatStyleGroup')
        this.chatStyleDiscussion    = this.initValue('chatStyleDiscussion')
        this.colorCoding            = this.initValue('colorCoding')
        this.backgroundColor        = this.initValue('backgroundColor')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'openChatMenu')
        this.valueToJson(result, 'openChatLink')
        this.valueToJson(result, 'chatStyleOneToOne')
        this.valueToJson(result, 'chatStyleGroup')
        this.valueToJson(result, 'chatStyleDiscussion')
        this.valueToJson(result, 'colorCoding')
        this.valueToJson(result, 'backgroundColor')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
